import { FormProvider, useForm } from "react-hook-form";
import React from "react";
import { useClient } from "../../../hooks";
import { Page } from "../../../components/common";
import { Alert } from "reactstrap";
import { SubmitButton } from "../../../@coherent/react-hook-form";
import { ReferralForm } from "./components/ReferralForm";
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom";

export const VolunteerReferralView = () => {
  const methods = useForm({
    mode: "onBlur",
  });
  const { handleSubmit, formState } = methods;
  const { isValid, submitCount } = formState;
  const client = useClient();
  const history = useHistory();

  async function onSubmit(x) {
    await client.post("volunteer_referrals", x).get("data");
    NotificationManager.success("Application created");
    history.push("/volunteer_applications");
  }

  const container = (children) => (
    <Page title="Refer a Lunchmaker">{children}</Page>
  );

  return (
    <FormProvider {...methods}>
      {container(
        <>
          <form noValidate onSubmit={handleSubmit(onSubmit)}>
            <ReferralForm />
            {submitCount && !isValid ? (
              <Alert color="danger">Please complete all fields.</Alert>
            ) : null}
            <div className="tw-flex tw-justify-end">
              <SubmitButton>Submit referral</SubmitButton>
            </div>
          </form>
        </>
      )}
    </FormProvider>
  );
};
